import { render, staticRenderFns } from "./NavHamburger.vue?vue&type=template&id=0fa1d8e4"
import script from "./NavHamburger.vue?vue&type=script&lang=js"
export * from "./NavHamburger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports